import { Button, Tabs } from "antd";
import { CustomerPersonalDetailsCommentsAndHistoryPanel } from "../types";
import { useState } from "react";
import Comments from "./Comments";
import History from "./History";
import AddCommentPopup from "./AddCommentPopup";

export function CommentsAndHistoryPanel(props: CustomerPersonalDetailsCommentsAndHistoryPanel) {
    const { studentDetails } = props;
    const [activeKey, setActiveKey] = useState("1");
    const [commentsKey, setCommentsKey] = useState(0);

    const handleAddCommentClick = () => {
        setActiveKey("1");
    };

    function refetchComments() {
        // console.log(studentDetails);
        return setCommentsKey(prevKey => prevKey + 1);
    }

    return (
        <div>
            <Tabs activeKey={activeKey} onChange={setActiveKey}
                tabBarExtraContent={
                    <AddCommentPopup id={props.studentDetails.id} valueUpdater={refetchComments}></AddCommentPopup>
                }
                items={[
                    { key: "1", label: "Comments", children: <Comments key={commentsKey} studentDetails={studentDetails} /> },
                    { key: "2", label: "History", children: <History key={activeKey} studentDetails={studentDetails} /> },
                ]} />
        </div>
    );
}